import { render, staticRenderFns } from "./TraceProductPopup.vue?vue&type=template&id=09b4e656&scoped=true&"
import script from "./TraceProductPopup.vue?vue&type=script&lang=js&"
export * from "./TraceProductPopup.vue?vue&type=script&lang=js&"
import style0 from "./TraceProductPopup.vue?vue&type=style&index=0&id=09b4e656&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b4e656",
  null
  
)

export default component.exports